import { Box, Divider, IconButton, withStyles } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { distances } from '@setvi/shared/styles';

interface HeaderProps {
  elements: {
    key: string;
    icon: JSX.Element;
    onClick?: () => void;
  }[];
  title: string;
}

const StyledBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: distances.px.base,
    borderRadius: 'inherit',
    justifyContent: 'space-between',

    '& button': {
      padding: 2,
      margin: 0
    }
  }
}))(Box);

const Header = ({ title, elements }: HeaderProps) => (
  <Box>
    <StyledBox>
      <SText weight="semibold" title={title}>
        {title}
      </SText>
      <Box display="flex" alignItems="center" gridGap={6}>
        {elements.map(({ icon, key, onClick }) => (
          <IconButton key={key} onClick={onClick}>
            {icon}
          </IconButton>
        ))}
      </Box>
    </StyledBox>
    <Divider />
  </Box>
);

export default Header;
